var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRealestate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16663 8.16667H5.16663C4.23321 8.16667 3.76649 8.16667 3.40998 8.34832C3.09637 8.50811 2.8414 8.76308 2.68162 9.07668C2.49996 9.4332 2.49996 9.89991 2.49996 10.8333V16.5M17.5 16.5V4.16667C17.5 3.23325 17.5 2.76654 17.3183 2.41002C17.1585 2.09641 16.9035 1.84144 16.5899 1.68166C16.2334 1.5 15.7667 1.5 14.8333 1.5H11.8333C10.8999 1.5 10.4332 1.5 10.0766 1.68166C9.76304 1.84144 9.50807 2.09641 9.34828 2.41002C9.16663 2.76654 9.16663 3.23325 9.16663 4.16667V16.5M18.3333 16.5H1.66663M12.0833 4.83333H14.5833M12.0833 8.16667H14.5833M12.0833 11.5H14.5833",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealestate);
export default __webpack_public_path__ + "static/media/realestate.a72826d34fbfe7f8bec592a163ca86b7.svg";
export { ForwardRef as ReactComponent };